<template>
  <div class="container" v-if="profile.response.admin">
    <div class="box">
      <div class="columns">
        <section class="column is-one-quarter">
          <aside class="menu">
            <p class="menu-label">
              Administration
            </p>
            <ul class="menu-list">
              <li>
                <router-link to="/settings/dashboard">
                   <i class="ion-md-grid"></i> Dashboard
                </router-link>
              </li>
              <li>
                <router-link to="/settings/users">
                   <i class="ion-md-people"></i> User Management
                </router-link>
              </li>
              <li>
                <router-link to="/settings/company">
                   <i class="ion-md-business"></i> Company Management
                </router-link>
              </li>
              <li>
                <router-link to="/settings/productlist">
                   <i class="ion-md-list"></i> Product List Management
                </router-link>
              </li>
              <li>
                <router-link to="/settings/roofmodel">
                   <i class="ion-md-cube"></i> Roof Models
                </router-link>
              </li>
              <li>
                <router-link to="/settings/components">
                   <i class="ion-md-switch"></i> Components
                </router-link>
              </li>
            </ul>
          </aside>
        </section>
        <section class="column is-three-quarters">
          <router-view></router-view>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import userStore from '@/store/userStore';

export default {
  title: 'Settings • BMI Pricing Calculator',

  data() {
    return {
      profile: userStore,
    };
  },
};
</script>
